import { useIntl } from 'react-intl'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import smileIcon from 'assets/icons/smileOrange_noBackground.svg'
import Input from 'components/shared/Input'
import { useErrorMessages } from 'utils/hooks/useErrorMessages'

export interface HandleInputProps {
    group: 'adults' | 'kids' | 'infants'
    index: number
    id: 'name' | 'surname'
    value: string
}

interface CredentialProps {
    name: string
    surname: string
    index: number
    group: 'adults' | 'kids' | 'infants'
    handleInputChange: ({ group, index, id, value }: HandleInputProps) => void
    bungalowIndex: number
}

const PersonCredentials = ({
    name,
    surname,
    index,
    group,
    handleInputChange,
    bungalowIndex,
}: CredentialProps) => {
    const { formatMessage } = useIntl()
    const { getError, handleRemoveError } = useErrorMessages()

    const renderTitle = () => {
        switch (group) {
            case 'adults':
                return formatMessage({
                    defaultMessage: 'Dorosły',
                    id: 'global.input.adult_label',
                })
            case 'kids':
                return formatMessage({
                    defaultMessage: 'Dziecko (do 12 lat)',
                    id: 'global.input.child_under_12_label',
                })
            case 'infants':
                return formatMessage({
                    defaultMessage: 'Dziecko (do 3 lat)',
                    id: 'global.input.child_under_3_label',
                })
        }
    }

    const nameId = `${group}-${index}-name-${bungalowIndex}`
    const surnameId = `${group}-${index}-surname-${bungalowIndex}`

    return (
        <Box gap={12} isFullWidth>
            <Box direction="row" align="center" gap={12} isFullWidth>
                <img src={smileIcon} alt="Smile Icon" />
                <Text variant="body" color="grayscale_900">
                    {renderTitle()}
                </Text>
            </Box>
            <Box gap={[24, 40]} direction={['column', 'row']} isFullWidth>
                <Input
                    type="text"
                    id={nameId}
                    onChange={(value) => {
                        handleRemoveError(nameId)
                        handleInputChange({ group, index, id: 'name', value })
                    }}
                    label={formatMessage({
                        id: 'global.input.first_name_label',
                        defaultMessage: 'Imię',
                    })}
                    placeholder={formatMessage({
                        id: 'global.input.first_name_placeholder',
                        defaultMessage: 'Imię',
                    })}
                    value={name}
                    hasNoMaxWidth={true}
                    isError={!!getError(nameId)}
                    errorMessage={getError(nameId)}
                    testId={`accommo-${bungalowIndex}-field-guest-${index}-first-name`}
                />
                <Input
                    type="text"
                    id={surnameId}
                    onChange={(value) => {
                        handleRemoveError(surnameId)
                        handleInputChange({
                            group,
                            index,
                            id: 'surname',
                            value,
                        })
                    }}
                    label={formatMessage({
                        id: 'global.input.last_name_label',
                        defaultMessage: 'Nazwisko',
                    })}
                    placeholder={formatMessage({
                        id: 'global.input.last_name_placeholder',
                        defaultMessage: 'Nazwisko',
                    })}
                    value={surname}
                    hasNoMaxWidth={true}
                    isError={!!getError(surnameId)}
                    errorMessage={getError(surnameId)}
                    testId={`accommo-${bungalowIndex}-field-guest-${index}-last-name`}
                />
            </Box>
        </Box>
    )
}

export default PersonCredentials
